/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface Label
 */
export interface Label {
    /**
     * `Label Primary Key`
     * @type {number}
     * @memberof Label
     */
    readonly id: number;
    /**
     * `Only Admin can use this field` *Readonly for another users*
     * @type {number}
     * @memberof Label
     */
    owner_id?: number;
    /**
     * @type {string}
     * @memberof Label
     */
    label: string;
}
